<div class="pa-editor">
  @if (label) {
    <label class="line-label" [for]="valueAccessor.inputId">
      <span>{{ label }}</span>
      @if (tooltip) {
        <i
          class="pi pi-question-circle"
          [pTooltip]="tooltip"
          tooltipPosition="right"
          hideDelay="300"
        ></i>
      }
    </label>
  }

  <p-editor
    [formControl]="valueAccessor.control"
    [formats]="formats"
    [placeholder]="placeholder"
    [style]="editorStyle"
    (onInit)="handleEditorInit($event)"
  >
    <ng-template #header>
      <span class="ql-formats">
        <select class="ql-header">
          <option value="" selected>T Текст</option>
          <option value="1">H1&nbsp;Заголовок</option>
          <option value="2">H2&nbsp;Заголовок</option>
          <option value="3">H3&nbsp;Заголовок</option>
          <option value="4">H4&nbsp;Заголовок</option>
        </select>
      </span>
      <span class="ql-formats">
        <button type="button" class="ql-bold" aria-label="Жирный"></button>
        <button type="button" class="ql-italic" aria-label="Курсив"></button>
        <button
          type="button"
          class="ql-underline"
          aria-label="Подчеркнутый"
        ></button>
      </span>
      <span class="ql-formats">
        <button
          type="button"
          class="ql-list"
          value="bullet"
          aria-label="Маркированный список"
        ></button>
        <button
          type="button"
          class="ql-list"
          value="ordered"
          aria-label="Нумерованный список"
        ></button>
      </span>
      <span class="ql-formats">
        <button type="button" class="ql-clean" aria-label="Очистить"></button>
      </span>
    </ng-template>
  </p-editor>

  @if (hint) {
    <small>{{ hint }}</small>
  }
</div>
